import { getRefusalReason } from '@tunasong/redux'

/**
 * What the error toast says when a command fails (GH #2386). Never the server's text (docs/ai-language.md): an
 * RTK rejection is a plain object whose `data` is the server body, so it gets a human line. A thrown `Error` is the
 * app's own text and keeps its message. The full error still goes to the logger.
 *
 * Copy (Joni): the toast title names the command, so "this" points at it. Who couldn't do what, then the next
 * step; never "Something went wrong", never "Nothing changed" (some commands partly apply), never "this month".
 */
export const commandErrorMessage = (error: unknown): string => {
  if (error instanceof Error) {
    return error.message
  }
  if (getRefusalReason(error) === 'quota-exceeded') {
    return "You've used all your AI tokens, so Tunabrain couldn't do this."
  }
  return "Tunasong couldn't finish this. Try again in a moment."
}
